import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SIRCON_AUT_MAIL;
const resourceFirstEmail = process.env.VUE_APP_RESOURCE_SIRCON_MAIL_AUTH;

export default {
  post(payload) {
    return baseApi.post(resource, payload);
  },

  firstEmail(payload) {
    return baseApi.post(resourceFirstEmail, payload);
  },
};
